var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCircleSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.67651C0 5.68739 0.790176 3.77974 2.1967 2.37321C3.60322 0.96669 5.51088 0.176514 7.5 0.176514C9.48912 0.176514 11.3968 0.96669 12.8033 2.37321C14.2098 3.77974 15 5.68739 15 7.67651C15 9.66564 14.2098 11.5733 12.8033 12.9798C11.3968 14.3863 9.48912 15.1765 7.5 15.1765C5.51088 15.1765 3.60322 14.3863 2.1967 12.9798C0.790176 11.5733 0 9.66564 0 7.67651ZM7.072 10.8865L11.39 5.48851L10.61 4.86451L6.928 9.46551L4.32 7.29251L3.68 8.06051L7.072 10.8865Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleSolid);
export default __webpack_public_path__ + "static/media/tick-circle-solid.0b2eab2bfee2fb4dc22e0fef361ea161.svg";
export { ForwardRef as ReactComponent };